import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-smriti',
  templateUrl: './smriti.component.html',
  styleUrls: ['./smriti.component.scss']
})
export class SmritiComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getSmriti();
  }

}
